import Vue from 'vue'

const mixins = Vue.mixin({
  computed: {
    _() {
      return this.$store.state.wording;
    }
  },
  methods: {
    slugify(text, ampersand = 'and') {
      const a = 'àáäâèéëêìíïîòóöôùúüûñçßÿỳýœæŕśńṕẃǵǹḿǘẍźḧ'
      const b = 'aaaaeeeeiiiioooouuuuncsyyyoarsnpwgnmuxzh'
      const p = new RegExp(a.split('').join('|'), 'g')

      return text.toString().toLowerCase()
          .replace(/[\s_]+/g, '-')
          .replace(p, c =>
              b.charAt(a.indexOf(c)))
          .replace(/&/g, `-${ampersand}-`)
          .replace(/[^\w-]+/g, '')
          .replace(/--+/g, '-')
          .replace(/^-+|-+$/g, '')
    },
    getOrderedPages(pages) {
      return [...pages].sort((a, b) => a.order - b.order);
    },
    getAdjacentPageId(pages, currentPageId, direction) {
      const orderedPages = this.getOrderedPages(pages);
      const currentIndex = orderedPages.findIndex(page => page.id == currentPageId);
      if (currentIndex === -1) {
        return null;
      }
      const adjacentIndex = currentIndex + direction;
      if (adjacentIndex < 0 || adjacentIndex >= orderedPages.length) {
        return null;
      }
      return orderedPages[adjacentIndex].id;
    },
    newPage(pages, nextPage) {
      let Page = pages.find(page => page.id == nextPage);
      switch (Page.setting_page_type_id) {
        case 1: {
          if (this.$route.name === 'dynamic') return './' + Page.id;
          return 'dynamic/' + Page.id;
        }
        case 2: {
          if (this.$route.name === 'dynamic') return '../authors';
          return 'authors';
        }
        case 3: {
          if (this.$route.name === 'dynamic') return '../submit';
          return 'submit';
        }
        case 4: {
          if (this.$route.name === 'dynamic') return '../payment';
          return 'payment';
        }
      }
    },
    hasNextSite(pages, currentPage) {
      return this.getAdjacentPageId(pages, Number(currentPage), 1) !== null;
    },
    nextSite(pages, currentPage) {
      const nextPageId = this.getAdjacentPageId(pages, Number(currentPage), 1);
      if (!nextPageId) {
        return null;
      }
      return this.newPage(pages, nextPageId);
    },
    hasPreviousSite(pages, currentPage) {
      return this.getAdjacentPageId(pages, Number(currentPage), -1) !== null;
    },
    previousSite(pages, currentPage) {
      const previousPageId = this.getAdjacentPageId(pages, Number(currentPage), -1);
      if (!previousPageId) {
        return '/home';
      }
      return this.newPage(pages, previousPageId);
    },
    containsKey(obj, key) {
      return Object.keys(obj).includes(key);
    },
    countryData() {
      let data = [];
      this.$store.state.countries.forEach((element, index) => {
        if (this.containsKey(this.$store.state.wording[0].country, element.iso_3166_alpha2)) {
          let cname = this.$store.state.wording[0].country[element.iso_3166_alpha2];
          data.push({'label': cname, 'id': element.iso_3166_alpha2})
        }
      });
      data.sort(function (a, b) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      return data;
    },
    getAccountUrl() {
      return process.env.VUE_APP_AUTH_URL + 'application/' + process.env.VUE_APP_AUTH_KEY + '?profile=true';
    }
  }
});

export default mixins
